import React from 'react';

export const divider = <div className='menu-divider' />;